export const paymentTypeList = [
  "Cash",
  "Card",
  "Room Charge",
  // "AR Account",
  // "Round Redeem",
  // "Credit Book",
  // "Comp Redemption",
  // "Offer Redemption",
  // "V1 Gift Card",
  // "V1 Gift Card IdTech",
  // "Agilysys Gift Card",
  // "Agilysys Gift Card IdTEch",
  "City Ledger",
  "Authorize Payment",
];

export const phoneRestrictionsList = [
  "None",
  "All calls allowed",
  "All calls Restricted",
  "No direct dial calls allowed",
  "Only local calls allowed",
  "Internal Calls Only",
];
